import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import OtpInput from "react-otp-input";
import Style from "./VerifyOTPForm.module.scss";
import InfiniteDotLoader from "../InfiniteDotLoader";
import { useSelector } from "react-redux";

var time = 60;

const VerifyOTPForm = ({
  phone,
  dialCode,
  email,
  editButton,
  otp,
  setOTP,
  isOTPverifying,
  isOtpError,
  otpSubmitButton,
  resendCallback,
  statusOTPcall,
  otpDetails,
  otpErrorMessage,
  otpCounter,
  setOtpCounter,
  formatOTP,
}) => {
  const [isOtpVerification, setIsOtpVerification] = useState(false);
  const [showResendOTPButton, setShowResendOTPButton] = useState(true);
  const [timer, setTimer] = useState(60);
  const timeOutCallback = useCallback(
    () => setTimer((currTimer) => currTimer - 1),
    []
  );
  const { registerOtpData } = useSelector((state) => state.auth);

  return (
    <>
      <h1 className={Style.Login__title}>OTP Verification</h1>
      <p className={Style.Login__description}>
        {phone != "" && dialCode != ""
          ? `OTP  has been sent on your registered mobile number ${dialCode} ${phone}`
          : ""}
        {email != ""
          ? `OTP  has been sent on your registered email address ${email}`
          : ""}
        <span
          // to="/register"
          className={`${Style.editBtn} btn btn-link`}
          onClick={() => editButton()}
        >
          Edit
        </span>
      </p>
      <div className="form-group otp-inputs center">
        <div className="input-holder">
          <OtpInput
            value={otp}
            numInputs={4}
            shouldAutoFocus={true}
            inputType="number"
            /*****************************************
             * CHECKING INPUT VALUE IS NUMBER OR NOT *
             *****************************************/
            onChange={(value) => {
              if (/^-?\d+$/.test(value) || value === "") {
                setOTP(value);
              }
            }}
            renderInput={(props) => (
              <input
                {...props}
                disabled={isOTPverifying}
                className={`${isOtpError == true ? Style.input_Style_error : ""}`}
              />
            )}
          />
        </div>
      </div>

      {otpErrorMessage && <p className="form-error-note">Invalid OTP</p>}

      <button
        type="submit"
        className={`${Style.Login__button} btn btn-primary w-100 mb-4`}
        onClick={otpSubmitButton}
        disabled={statusOTPcall}
      >
        {isOTPverifying === true ? <InfiniteDotLoader /> : "Submit"}
      </button>
      <div className={Style.Auth__option}>
        <span>Didn't Receive the OTP? </span>
        {otpCounter !== 0 && formatOTP(otpCounter)}
        {otpCounter == 0 ? (
          <button
            className="btn btn-link link-primary"
            onClick={() => {
              resendCallback();
              setOtpCounter(180);
            }}
          >
            Resend OTP
          </button>
        ) : (
          ""
        )}

        {/* {otpCounter == 0 &&
        <button
          className="btn btn-link link-primary"
          onClick={() => {
            // if (timer === 0) {
              resendCallback();
            // }
          }}
        >
          {" "}
          {timer === 0 ? "Resend OTP" : `Resend OTP (${timer})`}{" "}
        </button>} */}
      </div>
    </>
  );
};

export default VerifyOTPForm;
